import { createSlice } from '@reduxjs/toolkit';
import { clientVoicesService } from '../services';

const GEOLOCATION_UNAVAILABLE = -1;

const clientVoicesSlice = createSlice({
    name: 'clientVoices',
    initialState: {
        voices: {},
        approved: false,
        approving: false,
        approvedError: null,
        isFirstVoice: true,
        showApprovedInfoDialog: false,
        neverShowApprovedInfoDialog: localStorage.getItem('neverShowApprovedInfoDialog') === 'true'
    },
    reducers: {
        setVoice(state, action) {
            const { requestId, liked } = action.payload;
            state.voices[requestId] = liked;
            clientVoicesService.setVoice(requestId, liked);
            if (state.approved || !state.isFirstVoice) return;
            if (state.isFirstVoice) {
                if (!state.neverShowApprovedInfoDialog) state.showApprovedInfoDialog = true;
                state.isFirstVoice = false;
            }
        },
        setVoices(state, action) {
            const { voices, approved } = action.payload;
            state.voices = voices;
            state.approved = approved;
            state.approvedError = null;
        },
        setHasToken(state, action) {
            state.approved = action.payload;
            state.approvedError = null;
            state.approving = false;
        },
        setCreateTokenError(state, action) {
            state.approvedError = action.payload;
            state.approving = false;
            state.showApprovedInfoDialog = false;
            state.isFirstVoice = true;
        },
        setNeverShowApprovedInfoDialog(state, action) {
            state.neverShowApprovedInfoDialog = action.payload;
            localStorage.setItem('neverShowApprovedInfoDialog', state.neverShowApprovedInfoDialog);
        },
        hideApprovedInfoDialog(state) {
            state.showApprovedInfoDialog = false;
        },
        startApproving(state) {
            state.approving = true;
            state.approvedError = null;
        }
    }
});

export const {
    setVoice,
    setVoices,
    setHasToken,
    setCreateTokenError,
    setNeverShowApprovedInfoDialog,
    hideApprovedInfoDialog,
    startApproving
} = clientVoicesSlice.actions;
export default clientVoicesSlice.reducer;

export const fetchClientVoices = () => async dispatch => {
    const voices = await clientVoicesService.getVoices();
    dispatch(setVoices(voices));
};

export const approveClient = () => async dispatch => {
    let position;
    dispatch(startApproving());
    try {
        position = await getClientPosition();
    } catch (error) {
        switch (error.code) {
            case GEOLOCATION_UNAVAILABLE:
                return dispatch(
                    setCreateTokenError(
                        'Ваш браузер не поддерживает АПИ геолокации. Мы не можем подтвердить ваше положение.'
                    )
                );
            case error.PERMISSION_DENIED:
                // Пользователь нажал "Не разрешаю". Закрываем диалог.
                return dispatch(hideApprovedInfoDialog());
            default:
                return dispatch(setCreateTokenError('Не удалось определить ваши координаты. Попробуйте еще раз.'));
        }
    }

    try {
        await clientVoicesService.createToken(position.coords.latitude, position.coords.longitude);
        return dispatch(setHasToken(true));
    } catch (e) {
        if (e.reason === 'server') return dispatch(setCreateTokenError(e.message));
        return dispatch(setCreateTokenError('Что-то пошло не так. Попробуйте еще, может повезет.'));
    }
};

function getClientPosition() {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };
            navigator.geolocation.getCurrentPosition(
                position => resolve(position),
                error => reject(error),
                options
            );
        } else {
            const error = new Error('geolocation unavailable');
            error.code = GEOLOCATION_UNAVAILABLE;
            reject(error);
        }
    });
}
